/**
 * @generated SignedSource<<8333e0fcfd42e31135c30b6cdef9334f>>
 * @relayHash 091ad05d157265a053eabe2d0fa40a22
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 091ad05d157265a053eabe2d0fa40a22

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DestroyGradingCommentInput = {
  clientMutationId?: string | null;
  gradingCommentId: string;
};
export type gradingDestroyCommentMutation$variables = {
  input: DestroyGradingCommentInput;
};
export type gradingDestroyCommentMutation$data = {
  readonly destroyGradingComment: {
    readonly deletedId: string;
  } | null;
};
export type gradingDestroyCommentMutation = {
  response: gradingDestroyCommentMutation$data;
  variables: gradingDestroyCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DestroyGradingCommentPayload",
    "kind": "LinkedField",
    "name": "destroyGradingComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "gradingDestroyCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "gradingDestroyCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "091ad05d157265a053eabe2d0fa40a22",
    "metadata": {},
    "name": "gradingDestroyCommentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "da84a4e070efd30e169b5d7861b7badf";

export default node;
